import React, { Component } from 'react';
import './CalculatorForm.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { Form, Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import './CalculatorForm.css';

class CalculatorForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dogName: '',
            dogSize: null,
            dogYears: null,
            dogMonths: 0,
            errors: [],
            isValid: false
        }
    }

    onDogNameInputChange = (event) => {
        this.setState(
            {
                dogName: event.target.value,
            }
        );
    }

    onDogSizeInputChange = (event) => {
        this.setState(
            {
                dogSize: event.target.value,
            }
        );
    }

    onDogYearsInputChange = (event) => {
        this.setState(
            {
                dogYears: event.target.value,
            }
        );
    }

    onDogMonthsInputChange = (event) => {
        this.setState(
            {
                dogMonths: event.target.value,
            }
        );
    }

    validateForm = () => {
        const errors = [];

        if (this.state.dogName.length === 0) {
            errors.push({
                fieldId: "dog-name",
                text: 'Obavezno polje.'
            });
        }

        if (!this.state.dogSize) {
            errors.push({
                fieldId: "dog-size",
                text: 'Obavezno polje.'
            });
        }

        if (!this.state.dogYears) {
            errors.push({
                fieldId: "dog-years",
                text: 'Obavezno polje.'
            });
        } else if (this.state.dogYears > 16) {
            errors.push({
                fieldId: "dog-years",
                text: 'Maksimum 16.'
            });
        }

        if (this.state.dogMonths > 12) {
            errors.push({
                fieldId: "dog-months",
                text: 'Maksimum 12.'
            });
        }

        if (errors.length > 0) {
            this.setState(
                {
                    errors: errors,
                    isValid: false
                }
            );
        } else {
            this.setState(
                {
                    errors: [],
                    isValid: true
                },
                () => {
                    this.props.formDataHandler({ ...this.state });
                });
        }
    }

    displayError = (fieldName) => {
        const error = this.state.errors.find((error) => {
            return error.fieldId === fieldName;
        });

        return error ? error.text : null;
    }

    errorOnFieldExists = (fieldId) => {
        return this.state.errors.find((error) => error.fieldId === fieldId) ? 'is-invalid' : null;

    }

    render() {
        return (
            <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                <Form>
                    <Row>
                        <Form.Group as={Col} xs="12" sm="6" md="4" controlId="dog-name">
                            <Form.Label>Ime psa: *</Form.Label>
                            <Form.Control
                                type="text"
                                onChange={this.onDogNameInputChange.bind(this)}
                                placeholder="npr. Lino"
                                className={this.errorOnFieldExists("dog-name")} />
                            <div className="invalid-feedback">
                                {this.displayError("dog-name")}
                            </div>
                        </Form.Group>
                        <Form.Group as={Col} xs="12" sm="6" md="4" controlId="dog-size">
                            <Form.Label>Veličina psa: * <OverlayTrigger
                                key="bottom"
                                placement="bottom"
                                overlay={
                                    <Tooltip id="dog-size-tooltip">
                                        Veličinu možeš odrediti prema okvirnoj kilaži odraslog psa.
                                    </Tooltip>
                                }
                            >
                                <FontAwesomeIcon
                                    icon={faQuestionCircle}
                                    className="questionmark-icon"
                                />
                            </OverlayTrigger>
                            </Form.Label>
                            <Form.Control as="select"
                                onChange={this.onDogSizeInputChange.bind(this)}
                                className={this.errorOnFieldExists("dog-size") + " custom-select"}
                            >
                                <option value="" defaultValue>Odaberi veličinu</option>
                                <option value="small">Mali ({'<9kg'})</option>
                                <option value="medium">Srednji ({'9-22kg'})</option>
                                <option value="big">Veliki ({'22-45kg'})</option>
                                <option value="great">Jako veliki ({'>45kg'})</option>
                            </Form.Control>
                            <div className="invalid-feedback">
                                {this.displayError("dog-size")}
                            </div>
                        </Form.Group>
                        <Form.Group as={Col} xs="12" sm="6" md="2" controlId="dog-years">
                            <Form.Label>Godine: *</Form.Label>
                            <Form.Control
                                type="number"
                                onChange={this.onDogYearsInputChange.bind(this)}
                                className={this.errorOnFieldExists("dog-years")}
                                placeholder="npr. 3"
                                min={0}
                                max={16}
                            />
                            <div className="invalid-feedback">
                                {this.displayError("dog-years")}
                            </div>
                        </Form.Group>
                        <Form.Group as={Col} xs="12" sm="6" md="2" controlId="dog-months">
                            <Form.Label>Mjeseci: *</Form.Label>
                            <Form.Control
                                type="number"
                                onChange={this.onDogMonthsInputChange.bind(this)}
                                className={this.errorOnFieldExists("dog-months")}
                                placeholder="npr. 6"
                                min={0}
                                max={12}
                                disabled={this.state.dogYears >= 16 ? true : false}
                                value={this.state.dogYears >= 16 ? 0 : this.state.dogMonths > 0 ? this.state.dogMonths : ''}
                            />
                            <div className="invalid-feedback">
                                {this.displayError("dog-months")}
                            </div>
                        </Form.Group>
                    </Row>
                    <Row>
                        <Col
                            xs={{ span: 12 }}
                            sm={{ span: 4, offset: 8 }}
                            md={{ span: 3, offset: 9 }}
                        >
                            <Button
                                variant="primary"
                                onClick={this.validateForm}
                                className="float-right"
                                block
                            >Izračunaj</Button>
                        </Col>
                    </Row>
                </Form>
            </div >
        )
    }
}

export default CalculatorForm;